import { Link } from 'react-router-dom';
import { NameEmailForm } from '@/shared/components/forms';
import type { NameEmailFormData } from '@/shared/components/forms';

interface FooterLinkGroup {
  title: string;
  links: Array<{ label: string; path: string }>;
}

const footerLinkGroups: FooterLinkGroup[] = [
  {
    title: 'Navigation',
    links: [
      { label: 'Home', path: '/' },
      { label: 'How It Works', path: '/how-it-works' },
      { label: 'Results', path: '/results' },
      { label: 'Pricing', path: '/pricing' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Contact us', path: '/schedule-call' }
    ]
  },
  {
    title: 'Solutions',
    links: [
      { label: 'for Agents & Teams', path: '/agents' },
      { label: 'for Brokerages', path: '/brokerages' }
    ]
  }
];

export const Footer = () => {
  const handleDemoSubmit = async (_data: NameEmailFormData) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
  };

  return (
    <footer
      id="footer-3"
      className="footer ft-3-ntr pt--100 pt-[100px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] !pb-[50px] lg:max-xl:!pb-[35px] md:max-lg:!pb-[25px] sm:max-md:!pb-[30px] xsm:max-sm:!pb-[30px]"
    >
      <div className="container">
        {/* FOOTER CONTENT */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
          {/* FOOTER LOGO */}
          <div className="xl:w-3/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="footer-info !mb-[40px] lg:max-xl:!mb-[50px]">
              <img
                className="footer-logo w-auto max-w-[inherit] xl:!max-h-[40px] lg:max-xl:!max-h-[34px] md:max-lg:!max-h-[33px] sm:max-md:!max-h-[38px] xsm:max-sm:!max-h-[37px]"
                src="/images/logo-blue.png"
                alt="footer-logo"
              />
              <img
                className="footer-logo-dark hidden w-auto max-w-[inherit] xl:!max-h-[40px] lg:max-xl:!max-h-[34px] md:max-lg:!max-h-[33px] sm:max-md:!max-h-[38px] xsm:max-sm:!max-h-[37px]"
                src="/images/logo-blue-white.png"
                alt="footer-logo"
              />
            </div>
          </div>

          {/* FOOTER LINKS */}
          {footerLinkGroups.map(group => (
            <div
              key={group.title}
              className="sm:w-4/12 md:max-lg:w-4/12 lg:max-xl:w-3/12 xl:w-3/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full"
            >
              <div className="footer-links !mb-[40px] fl-1">
                <h6 className="s-17 w--700 xl:!text-[1.0625rem] lg:max-xl:!text-[1.0625rem] !leading-none xl:!mb-[25px] lg:max-xl:!mb-[20px] md:max-lg:!text-[1.17647rem] md:max-lg:!mb-[16px] sm:max-md:!text-[1.21875rem] sm:max-md:!mb-[20px] xsm:max-sm:!text-[1.21875rem] xsm:max-sm:!mb-[20px] font-Jakarta">
                  {group.title}
                </h6>
                <ul className="foo-links clearfix">
                  {group.links.map(link => (
                    <li
                      key={link.path}
                      className="w-auto block align-top clear-none !m-0 !p-0"
                    >
                      <p className="!font-normal !mb-[10px] md:max-lg:!mb-[8px]">
                        <Link to={link.path}>{link.label}</Link>
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}

          {/* FOOTER DEMO FORM */}
          <div className="sm:w-10/12 md:max-lg:w-8/12 lg:w-4/12 xl:w-3/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="footer-form !mb-[20px] lg:max-xl:!pl-[5%] sm:max-md:mr-[5%] xsm:max-sm:mr-[5%]">
              <h6 className="s-17 w--700 xl:!text-[1.0625rem] lg:max-xl:!text-[1.0625rem] !leading-none xl:!mb-[25px] lg:max-xl:!mb-[20px] md:max-lg:!text-[1.17647rem] md:max-lg:!mb-[16px] sm:max-md:!text-[1.21875rem] sm:max-md:!mb-[20px] xsm:max-sm:!text-[1.21875rem] xsm:max-sm:!mb-[20px] font-Jakarta">
                Watch Demo (Instant Access):
              </h6>
              <NameEmailForm
                onSubmit={handleDemoSubmit}
                submitText="Watch Demo Now"
                submittingText="Submitting..."
                namePlaceholder="Name"
                emailPlaceholder="Email Address"
                variant="footer"
                onSuccessMessage="Thank you! You will receive the demo shortly."
              />
              {/* SCHEDULE CALL SECTION */}
              {/* <hr className="mt-[30px] !mb-[30px] lg:max-xl:!mt-[10px] lg:max-xl:!mb-[25px] md:max-lg:!mt-[5px] md:max-lg:!mb-[20px] sm:max-md:!mt-[15px] sm:max-md:!mb-[25px] xsm:max-sm:!mt-[5px] xsm:max-sm:!mb-[25px]" />
              <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
                <div className="w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
                  <div className="">
                    <h6 className="s-17 w--700 xl:!text-[1.0625rem] lg:max-xl:!text-[1.0625rem] !leading-none xl:!mb-[25px] lg:max-xl:!mb-[20px] md:max-lg:!text-[1.17647rem] md:max-lg:!mb-[16px] sm:max-md:!text-[1.21875rem] sm:max-md:!mb-[20px] xsm:max-sm:!text-[1.21875rem] xsm:max-sm:!mb-[20px] font-Jakarta">
                      Contact us:
                    </h6>
                    <Link
                      to="/schedule-call"
                      style={{
                        display: 'inline-block',
                        color: '#185abd'
                      }}
                    >
                      Schedule Call &#187;
                    </Link>
                  </div>
                </div>
              </div> */}
              {/* END SCHEDULE CALL SECTION */}
            </div>
          </div>
        </div>
        {/* END FOOTER CONTENT */}

        <hr className="mt-[30px] !mb-[50px] lg:max-xl:!mt-[20px] lg:max-xl:!mb-[35px] md:max-lg:!mt-[15px] md:max-lg:!mb-[25px] sm:max-md:!mt-[20px] sm:max-md:!mb-[30px] xsm:max-sm:!mt-[15px] xsm:max-sm:!mb-[30px]" />

        {/* BOTTOM FOOTER */}
        <div className="bottom-footer">
          <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] row-cols-1 row-cols-md-2 items-center">
            {/* FOOTER COPYRIGHT */}
            <div className="w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
              <div className="footer-copyright">
                <p className="p-sm !mb-0">
                  &copy; 2026 BrokerMax. <span>All Rights Reserved</span>.{' '}
                  <Link to="/privacy-policy">Privacy Policy</Link>.{' '}
                  <Link to="/terms-of-service">Terms of Service</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
